
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { useQuery, gql } from '@apollo/client';
import { ApolloClient, InMemoryCache, ApolloProvider } from '@apollo/client';
import MainLayout from '../components/MainLayout';
import { Outlet, Navigate,Link } from "react-router-dom";
import { Redirect } from "react-router-dom";







function Login() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);//login
    const [redirect, setRedirect] = useState(false);
    
  
    const handleUsernameChange = (e) => setUsername(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      const client = new ApolloClient({
        uri: 'http://212.68.57.195:8080/v1/graphql',
        cache: new InMemoryCache(),
      });
  
      const LOGIN_QUERY = gql`
        query Login($username: String!, $password: String!) {
          tbl_login(where: { user_name: { _eq: $username }, pass: { _eq: $password } }) {
            user_name
          }
        }
      `;
      
      const { data } = await client.query({
        query: LOGIN_QUERY,
        variables: { username, password },
      });
  
      const success = data.tbl_login.length > 0;
  
      if (success) {
       // <Navigate to="/AuthLayout" replace/>;
        // Kullanıcı girişi başarılı, ana sayfaya yönlendir
        
       setError(isLoggedIn);
       setIsLoggedIn(true);
       localStorage.setItem('login', 'true');
       setRedirect(true); // set redirect flag

      
        
        
        
        
       
      } else {
        // Kullanıcı girişi başarısız, hata mesajı göster
        setError('Kullanıcı adı veya şifre yanlış.');
      }
    };

    if (redirect) {
        window.location.reload()
       // return <Navigate to="/"  />; // render the redirect here
      }
  
    return (
      <form onSubmit={handleSubmit}>
        <label>
          Kullanıcı Adı:
          <input type="text" value={username} onChange={handleUsernameChange} />
        </label>
        <label>
          Şifre:
          <input type="password" value={password} onChange={handlePasswordChange} />
        </label>
        <button type="submit">Giriş Yap</button>
        {error && <div>{error}</div>}
        
      </form>
    );
  }




/*const LOGIN_MUTATION = gql`
  mutation LoginMutation($userName: String!, $password: String!) {
    login(user_name: $userName, pass: $password) {
      token
    }
  }
`;

function LoginForm() {
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
  
    const [login, { loading, error }] = useMutation(LOGIN_MUTATION, {
      onCompleted({ login }) {
        localStorage.setItem('token', login.token);
        // Burada yönlendirme işlemini yapabilirsiniz.
      },
      onError() {
        // Hata işleme kodlarını burada yazabilirsiniz.
      },
    });
  
    function handleSubmit(e) {
      e.preventDefault();
      login({ variables: { userName, password } });
    }
  
    return (
      <form onSubmit={handleSubmit}>
        {error && <p>Authentication error</p>}
        <input type="text" value={userName} onChange={e => setUserName(e.target.value)} />
        <input type="password" value={password} onChange={e => setPassword(e.target.value)} />
        <button type="submit" disabled={loading}>Login</button>
      </form>
    );
  }*/
  
function SingUp() {
  return (
    <div className="App">
      <h1>Hasura GraphQL Login</h1>
      <Login />
    </div>
  );
}

export default SingUp;


